module.exports = __webpack_public_path__ + "img/type-sliding-door.3d134161.png";